/**
 * Primitive design tokens (spacing / radius / typography).
 *
 * These are NOT color tokens — color always comes from `theme.buttons.*` (and the rest of
 * `theme.*`) so it keeps changing correctly between light/dark. These are pure size/scale
 * primitives, with no reason to differ by theme, so `lightTheme`/`darkTheme`
 * (Context/constants.js) stay pure color palettes and don't import this file directly —
 * these tokens are merged in once, on top of whichever palette is active, by
 * `resolveThemeStyles` in Context/index.js.
 */

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px'
};

export const radius = {
  sm: '2px',
  md: '4px',
  lg: '8px',
  pill: '999px'
};

export const typography = {
  fontFamily: "'Sequel Sans', sans-serif",
  fontSize: {
    sm: '12px',
    md: '14px',
    lg: '16px'
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }
};
